import React from "react";
import Users from "../../Organizations/Users/Users";

const GovernanceFramework = () => {
  return <Users governance={true} expandList={true} org={true}/>;
};

export default GovernanceFramework;
